/**
 * Created by dfontenla
 */
angular.module('CarsSaraBo').directive('brazilCategoryBanner', function () {
    return {
        scope: {
            visibility: '=',
            country: '@'
        },

        link: function (scope) {

            scope.showBrazilCategoryBanner = function(){
                return 20028 == scope.country;
            }
        },
        templateUrl: 'assets/partial/notifications/brazil-category-banner.html'
    };
});



//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/bazil_category_banner_directive.js
// module id = 871
// module chunks = 3